import React, { useState } from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Alert from "@material-ui/lab/Alert";
import { useDispatch, useSelector } from "react-redux";
import { addPunch, updatePunch } from "../services";
import { getPunch, getUniqueID } from "../utils/punch";
import { categoryPunch } from "../pages/Punch/constants";
import { DEVICE_DETAILS } from "../../src/config/index";
import { useHistory, useLocation } from "react-router-dom";
import { dateConfig, TRANSFER, LAST, SET_EMPTY } from "../pages/Punch/config";
import moment from "moment";

const ConfirmMealTransferDialog = (props) => {
  const { t } = useTranslation();
  const [customerSite, setCustomerSite] = useState(SET_EMPTY);
  const [showMealEndConfirmation, setShowMealEndConfirmation] = useState(false);
  const [showNegativeMealEndConfirmation, setShowNegativeMealEndConfirmation] = useState(false);
  const [lastPunchInLocalTs, setLastPunchInLocalTs]= useState();

  const { error, loading, idNotificationMsg, user } = useSelector(
    (state) => state.user
  );
  const history = useHistory();

  const { ConfirmMealTransferDialog, setconfirmMealTransferDialog, lastPunch } =
    props;

  const callback = () => {
    history.goBack();
  };
  const mealEndHandler = (isActivityContinued) => {
    if (isActivityContinued) {
      const timeStamp = new Date();
      const outTS = timeStamp.toISOString();
      const actionTS = timeStamp.toISOString();
      const outLocalTS = moment(timeStamp).format(dateConfig.format4);
      const activityName = TRANSFER;
      const version = getUniqueID();
      lastPunch.outTS = outTS;
      lastPunch.actionTS = actionTS;
      lastPunch.outLocalTS = outLocalTS;

      let lastActivity = LAST + user.lastActGrp;
      const newPunch = getPunch(
        user.lastActGrp ? user.lastActGrp : "",
        activityName,
        lastPunch.buildingId,
        lastPunch.districtId,
        lastPunch.customerSite ? lastPunch.customerSite : customerSite,
        lastPunch.exceptionName,
        lastPunch.isException,
        lastPunch.jobName,
        user && user[lastActivity] ? user[lastActivity] : "",
        lastPunch.status,
        version,
        user.workerId,
        actionTS,
        outTS,
        outLocalTS,
        SET_EMPTY,
        SET_EMPTY,
        user.workerId,
        DEVICE_DETAILS,
        categoryPunch
      );
      const recentPunchIn = moment(lastPunch.inLocalTS).format(
        dateConfig.format7
      );
      const recentPunchOut = moment(outLocalTS).format(dateConfig.format7);
      if(lastPunch.projectDetails || lastPunch.projectDetails===SET_EMPTY){
        if(lastPunch.projectDetails === SET_EMPTY){
          newPunch.projectDetails = SET_EMPTY;
        }else newPunch.projectDetails =lastPunch.projectDetails;
        
      }
      if (recentPunchOut < recentPunchIn)
      {
        setLastPunchInLocalTs(recentPunchIn);
        setShowNegativeMealEndConfirmation(true);
       }
      else {
        updatePunch(lastPunch.punchId, lastPunch)
          .then(() => {
            addPunch(newPunch, false, false).then(() => {});
            setShowMealEndConfirmation(true);
          })
          .catch((error) => {
            console.log(error);
          });
      }  
    }
  };

  return (
    <>
      <Dialog
        open={showMealEndConfirmation}
        //onClose={() => mealEndHandler(true)}
        aria-labelledby="confirmation-dialog"
        disableBackdropClick
      >
        <DialogTitle id="form-dialog-title">
          {t("pgPunch.tlConfirmation")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("pgReview.dialogueMsgs.msgSuccess")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowMealEndConfirmation(false);
              history.goBack();
            }}
            color="primary"
          >
            {"OK"}
          </Button>
        </DialogActions>
      </Dialog>
      
      <Dialog
        open={showNegativeMealEndConfirmation}
        //onClose={closeNegativeMealEndModalConfirmationMsg}
        aria-labelledby="confirmation-dialog"
        disableBackdropClick
      >
        <DialogTitle id="form-dialog-title">
          {t("other.errMsgNegativePunchTitle")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText> {t("other.errMsgNegativePunch")}</DialogContentText>
          <DialogContentText> {t("other.errMsgNegativePunchTwo")} {lastPunchInLocalTs}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button  onClick={() => {
              // mealEndHandler(true);
              setShowNegativeMealEndConfirmation(false);
            }} color="primary">
            {t("pgPunch.btnOK")}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={ConfirmMealTransferDialog.isOpen}
        aria-labelledby="confirmation-dialog"
        disableBackdropClick
      >
        <DialogTitle id="form-dialog-title">
          {t(ConfirmMealTransferDialog.title)}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t(ConfirmMealTransferDialog.subTitle)}
          </DialogContentText>
        </DialogContent>
        {ConfirmMealTransferDialog.alertMsg && (
          <DialogContent>
            <Alert severity="warning">
              {t(ConfirmMealTransferDialog.alertMsg)}
            </Alert>
          </DialogContent>
        )}
        <DialogActions>
          <div
            style={{
              width: "96%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-evenly",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "96%",
                marginBottom: 10,
              }}
            >
              <Button
                style={{ width: "48%" }}
                variant="outlined"
                color="primary"
                onClick={() =>
                  setconfirmMealTransferDialog({
                    ...ConfirmMealTransferDialog,
                    isOpen: false,
                  })
                }
              >
                {t("pgPunch.btnTransfer")}
              </Button>
              <Button
                style={{ width: "48%" }}
                color="primary"
                variant="outlined"
                onClick={() => mealEndHandler(true)}
              >
                {t("other.btnContinueActivity")}
              </Button>
            </div>
            <div>
              <Button
                variant="contained"
                color="primary"
                style={{ minWidth: "96%" }}
                onClick={callback}
              >
                {t("other.btnContinueMeal")}
              </Button>
            </div>
          </div>
        </DialogActions>
        {/* <DialogActions>
        <Button
          variant="contained"
          color="primary"
          style={{width:"40%"}}
          onClick={callback}
        >
          Continue Meal
        </Button>
      </DialogActions> */}
      </Dialog>
    </>
    //229
  );
};

// Specifies the default values for props:
ConfirmMealTransferDialog.defaultProps = {
  ConfirmMealTransferDialog: {
    title: "pgPunch.tlConfirmation",
    subTitle: "pgReview.msgDeletePunch",
    alertMsg: "other.1",
  },
};

ConfirmMealTransferDialog.propTypes = {
  ConfirmMealTransferDialog: PropTypes.object.isRequired,
  setconfirmMealTransferDialog: PropTypes.func.isRequired,
  lastPunch: PropTypes.object.isRequired,
  onClickHandle: PropTypes.func.isRequired,
};

export default ConfirmMealTransferDialog;
